export const TRADE_EVENTS = {
  CLIENT: {
    JOIN: "joinTrade",
    LEAVE: "leaveTrade",
    SEND_MESSAGE: "sendMessage",
    TYPING_START: "typing:start",
    TYPING_STOP: "typing:stop",
    PAYMENT_SENT: "trade:payment_sent",
    CANCEL: "trade:cancel",
    RELEASE: "trade:release",
  },

  SERVER: {
    JOINED: "joinedTrade",
    NEW_MESSAGE: "newMessage",
    USER_TYPING: "userTyping",
    CREATED: "trade:created",
    PAID: "trade:paid",
    RELEASED: "trade:released",
    CANCELLED: "trade:cancelled",
    EXPIRED: "trade:expired",
    ERROR: "trade:error",
    STATUS_UPDATED: "trade:statusUpdated", // good for general updates
    DISPUTED: "trade:disputed",
  },
} as const;
